import { render, staticRenderFns } from "./particulares.vue?vue&type=template&id=338d972c"
import script from "./particulares.vue?vue&type=script&lang=js"
export * from "./particulares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports